import React from 'react'

export default ({ ...props }) => (
  <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx='32' cy='32' r='31.5' fill='white' stroke='#B7B7B7' />
    <path
      d='M29.0005 22.002C28.7445 22.002 28.4885 22.1 28.2925 22.294C27.9025 22.684 27.9025 23.318 28.2925 23.708L37.5845 33L28.2925 42.292C27.9025 42.682 27.9025 43.316 28.2925 43.706C28.6825 44.096 29.3165 44.096 29.7065 43.706L39.7065 33.706C40.0965 33.316 40.0965 32.682 39.7065 32.292L29.7065 22.292C29.5105 22.096 29.2545 22 28.9985 22L29.0005 22.002Z'
      fill='#0D0D0D'
    />
  </svg>
)
